import productionProductRequestsAPI from '../../services/productionProductRequestsAPI';
import purchaseRequestsAPI from '../../services/purchaseRequestsAPI';
import { notifyProductionProductRequestsChanged, notifyPurchaseRequestsChanged } from './commercialRequestsUtils';

const selectedLines = (lineItems = [], selectionMap = {}) =>
  (lineItems || [])
    .map((item) => {
      const id = Number(item.id);
      const row = selectionMap[id];
      if (!row?.enabled) return null;
      const qty = Number(row.quantity ?? item.quantity ?? 0);
      if (!(qty > 0)) return null;
      return { ...item, requested_quantity: qty };
    })
    .filter(Boolean);

export const createProductionRequestsFromQuotationClose = async ({
  lineItems = [],
  selectionMap = {},
  quotation = null,
  saleCode = '',
  dispatchDate = '',
  createdBy = '',
  notes = '',
}) => {
  const rows = selectedLines(lineItems, selectionMap);
  if (!rows.length) return [];

  const items = rows.map((item) => ({
    product_code: String(item.product_sku || item.item_code || '').trim(),
    product_name: String(item.item_name || item.product_name || '').trim(),
    color_code: String(item.color_code || '').trim(),
    color_name: String(item.color || '').trim(),
    formula_kind: 'color',
    quantity: Number(item.requested_quantity || 0),
    unit: String(item.unit || 'L').trim() || 'L',
  }));

  const payload = {
    origin: 'Comercial',
    reference: `Venta ${saleCode || quotation?.quotation_code || ''}`.trim(),
    needed_by_date: String(dispatchDate || '').slice(0, 10),
    status: 'Solicitado',
    quotation_code: String(quotation?.quotation_code || '').trim(),
    sale_code: String(saleCode || '').trim(),
    source: 'quotation_close',
    notes: String(notes || '').trim(),
    // Ejecutivo comercial responsable: se muestra como Origen en Planificación.
    created_by:
      String(createdBy || quotation?.user_full_name || '').trim() || 'system',
    items,
  };

  try {
    const created = await productionProductRequestsAPI.create(payload);
    notifyProductionProductRequestsChanged();
    return [created];
  } catch (error) {
    console.error('No se pudo crear solicitud T-COAT:', error);
    throw error;
  }
};

export const createUpsellingPurchaseRequestsFromQuotationClose = async ({
  lineItems = [],
  selectionMap = {},
  quotation = null,
  saleCode = '',
  dispatchDate = '',
  requesterName = '',
}) => {
  const rows = selectedLines(lineItems, selectionMap);
  if (!rows.length) return [];

  const items = rows.map((item, index) => ({
    line_order: (index + 1) * 10,
    item_code: String(item.product_sku || item.item_code || '').trim(),
    description: String(item.item_name || item.product_name || '').trim(),
    quantity: Number(item.requested_quantity || 0),
    unit: String(item.unit || 'UN').trim() || 'UN',
    estimated_unit_price: Number(item.unit_price || 0),
  }));

  const payload = {
    requester_name: String(requesterName || quotation?.user_full_name || '').trim() || 'Comercial',
    department: 'Comercial',
    request_date: new Date().toISOString().slice(0, 10),
    needed_by_date: String(dispatchDate || '').slice(0, 10),
    priority: 'Normal',
    status: 'Enviada',
    justification: `Upselling cotización ${quotation?.quotation_code || ''} / venta ${saleCode || ''}`.trim(),
    notes: 'Generada automáticamente al cerrar cotización como vendida (upselling).',
    items,
  };

  try {
    const created = await purchaseRequestsAPI.create(payload);
    notifyPurchaseRequestsChanged();
    return [created];
  } catch (error) {
    console.error('No se pudo crear solicitud de adquisiciones:', error);
    throw error;
  }
};
